import AlertRuleEdit from "@/pages/alerts/AlertRuleEdit";
import { openContextModal } from "@mantine/modals";

const AlertRuleEditModal = ({ context, id, innerProps }) => {
  const handleSave = (data) => {
    context.closeModal(id);
    innerProps.onSave(data);
  };

  const handleCancel = () => {
    context.closeModal(id);
  };

  return <AlertRuleEdit alertData={innerProps.alertData} onSave={handleSave} onCancel={handleCancel} />;
};

const openAlertRuleEditModal = (innerProps) => {
  openContextModal({
    modal: "AlertRuleEditModal",
    size: "md",
    title: `Edit Alert Rule: ${innerProps.alertData.alertName}`,
    centered: true,
    withCloseButton: true,
    closeOnClickOutside: false,
    closeOnEscape: false,
    innerProps,
  });
};

export { AlertRuleEditModal, openAlertRuleEditModal };
